export default "__VITE_ASSET__DgEx0se___"